import * as React from 'react'
import { ProgressBar } from './ui'
import { calculateUnitPayback, formatUnitProfit } from './unitPaybackModel'

export function UnitPayback({ assetCode, purchasePricePence, revenuePence, expanded = false }: {
  expanded?: boolean
  assetCode: string
  purchasePricePence: number | null
  revenuePence: number
}) {
  const payback = calculateUnitPayback(purchasePricePence, revenuePence)
  if (!payback) return <span className="ops-muted">{expanded ? "Purchase price or revenue not recorded." : "—"}</span>
  return <div className={`ops-unit-payback${expanded ? " ops-unit-payback-expanded" : ""}`}>
    <ProgressBar value={payback.progressPercentage} label={`${assetCode} purchase price paid off`} isLabelHidden
      variant={payback.profitPence == null ? 'warning' : 'success'} />
    <span className={payback.profitPence == null ? undefined : 'profit'}>
      {payback.profitPence == null ? `${payback.displayPercentage}%` : formatUnitProfit(payback.profitPence)}
    </span>
  </div>
}
